import { nsEnvelope } from '@/app/i18n/namespaces';
import ENVELOPE_STATUS from '../enums/EnvelopeStatus';

export default {
    UUID: {
        key: 'uuid'
    },
    CREATED_AT: {
        key: 'createdAt',
        type: 'date',
        entity: 'keys.envelopes.created_at',
        namespace: nsEnvelope,
        enableSorting: true,
        filter: 'date'
    },
    UPDATED_AT: {
        key: 'updatedAt',
        type: 'date',
        entity: 'keys.envelopes.updated_at',
        enableSorting: true,
        filter: 'date'
    },
    ACCESS_CODE: {
        key: 'accessCode',
        type: 'text',
        entity: 'keys.envelopes.access_code',
        placeholder: 'filter.placeholder.envelopes.access_code',
        namespace: nsEnvelope,
        enableSorting: true,
        filter: 'input'
    },
    STATUS: {
        key: 'status',
        type: 'select',
        entity: 'keys.envelopes.status',
        namespace: nsEnvelope,
        enableSorting: true,
        filter: 'select',
        enum: ENVELOPE_STATUS
    },
    DOWNLOAD_SERVER_IP_ADDRESS_PORT: {
        key: 'downloadServerIpAddressPort',
        type: 'text',
        entity: 'keys.envelopes.server_ip',
        placeholder: 'filter.placeholder.envelopes.download_server_ip_address_port',
        namespace: nsEnvelope,
        enableSorting: true,
        filter: 'input'
    },
    SCHEDULED_START_DATE: {
        key: 'scheduledStartDate',
        type: 'date',
        entity: 'keys.envelopes.schedule_start',
        namespace: nsEnvelope,
        shouldShowHours: true,
        enableSorting: true,
        filter: 'date'
    },
    SCHEDULED_END_DATE: {
        key: 'scheduledEndDate',
        type: 'date',
        entity: 'keys.envelopes.schedule_end',
        namespace: nsEnvelope,
        shouldShowHours: true,
        enableSorting: true,
        filter: 'date'
    },
    SENT_TO_TERMINAL_DATE: {
        key: 'sentToTerminalDate',
        type: 'date',
        entity: 'keys.envelopes.sent_at',
        namespace: nsEnvelope,
        enableSorting: true,
        filter: 'date'
    },
    CLIENT_NAME: {
        key: 'organizationLegalName',
        type: 'text',
        entity: 'keys.envelopes.client',
        placeholder: 'filter.placeholder.envelopes.client_name',
        namespace: nsEnvelope,
        enableSorting: true,
        filter: 'input'
    },
    POS_TERMINAL_SERIAL_NUMBER: {
        key: 'posTerminalSerialNumber',
        type: 'text',
        entity: 'keys.envelopes.serial_number',
        placeholder: 'filter.placeholder.envelopes.serial_number',
        namespace: nsEnvelope,
        enableSorting: true,
        filter: 'input'
    },
    ORGANIZATION_UUID: {
        key: 'organizationUuid',
        type: 'text'
    },
    POS_TERMINAL_UUIDS: {
        key: 'posTerminalUuids',
        type: 'text'
    }
};